import React from "react";
import FieldError from "../ui/error/FieldError";

const FileInput = ({
  label,
  name,
  onChange,
  error,
  className = "",
  ...props
}) => {
  return (
    <div className={className}>
      <label htmlFor={name} className="form-label">
        {label}
      </label>
      <input
        className="form-control"
        type="file"
        id={name}
        name={name}
        onChange={onChange}
        {...props}
      />
      {error && <FieldError error={error} />}
    </div>
  );
};

export default FileInput;
